<template>
  <div class="dropDown" v-show="visible">
    <van-field
      v-model="fieldValue"
      is-link
      readonly
      placeholder="不知道选哪些类别？您可以选择行业自动勾选"
      @click="show = true"
    />
    <!-- 类别 -->
    <div class="lei">
      <van-checkbox
        v-model="isCheckAll"
        :indeterminate="isIndeterminate"
        @change="checkAllChange"
        shape="square"
      >
        全选45类
      </van-checkbox>

      <van-checkbox-group v-model="checkedResult" @change="checkedResultChange">
        <van-checkbox
          v-for="item in list"
          :key="item"
          :name="item"
          shape="square"
        >
          复选框 {{ item }}
        </van-checkbox>
      </van-checkbox-group>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="不知道选哪些类别？您可以选择行业自动勾选"
        :options="options"
        @close="show = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>
<script>
import { getNclOne } from "@/api/tmSearchH5";
export default {
  props: {
    companyList: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    flag: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropItem: "",
      loadingItem: "",
      show: false,
      options: [
        {
          text: "浙江省",
          value: "330000",
          children: [{ text: "杭州市", value: "330100" }],
        },
        {
          text: "江苏省",
          value: "320000",
          children: [{ text: "南京市", value: "320100" }],
        },
      ],
      fieldValue: "",
      cascaderValue: "",
      list: ["a", "b", "c", "d"],
      isCheckAll: false,
      checkedResult: ["a", "b", "c", "d"],
      isIndeterminate: false,
    };
  },
  watch: {
    flag: {
      immediate: true,
      handler(val) {
        if (val == 0) {
          this.dropItem = "dropOne";
          this.loadingItem = "loadingOne";
        } else {
          this.dropItem = "dropTwo";
          this.loadingItem = "loadingTwo";
        }
      },
    },
  },
  created() {
    this.getNcl();
  },
  methods: {
    //获取分类
    getNcl() {
      // const res = await getNclOne()
      // plainOptions.value = res.data.map((n) => n.fullName) || []
      getNclOne()
        .then((res) => {
          if (res.data) {
            // this.companyList = [...new Set(res.data)];
            // if (res.data.length > 0) {
            //   this.companyShow = true;
            // }
          }
        })
        .catch((err) => console.log(err));
    },
    onClick(item) {
      this.$emit("checkName", item);
      this.$emit("update:visible", false);
    },
    checkAllChange(val) {
      this.checkedResult = val ? this.list : [];
      this.isIndeterminate = false;
    },

    checkedResultChange(value) {
      const checkedCount = value.length;
      this.isCheckAll = checkedCount === this.list.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.list.length;
    },
  },
};
</script>
<style lang="less" scoped>
.dropDown {
  //   width: 6.7rem;
  //   height: 3rem;
  overflow: auto;
  background-color: white;
  border-radius: 7px;
  box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.07);
  /deep/ .van-empty__image {
    width: 1.85rem;
    height: 1.85rem;
    display: flex;
    justify-content: center;
    margin-top: 0.45rem;
  }
  /deep/ .van-empty__description {
    margin-top: 0.05rem;
  }
  .loadingOne {
    margin-top: 1.8rem;
  }
  .loadingTwo {
    margin-top: 1.6rem;
  }
  .dropOne {
    padding-left: 0.3rem;
    height: 0.9rem;
    line-height: 0.9rem;
    div {
      width: 5.9rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &::after {
      content: "";
      position: absolute;
      left: 0.3rem;
      width: 6.1rem;
      height: 0.01rem;
      background: #f5f5f5;
    }
  }
  .dropTwo {
    padding-left: 0.2rem;
    height: 0.8rem;
    line-height: 0.8rem;
    div {
      width: 5.9rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &::after {
      content: "";
      position: absolute;
      left: 0.2rem;
      width: 6.1rem;
      height: 0.01rem;
      background: #f5f5f5;
    }
  }
}
</style>
